import { createFileRoute, redirect } from "@tanstack/react-router"
import Page from "modules/shared/components/Page"

export const Route = createFileRoute("/_base/_auth")({
  component: Page,
  beforeLoad: ({ context }) => {
    if (context.auth.authStatus === "not_authenticated") {
      throw redirect({ to: "/login" })
    }
  },
})
